import {Component} from '@angular/core';

@Component({
    templateUrl: './PaymentProcessingComponent.html',
    styleUrls: ['./PaymentProcessingComponent.scss'],
    standalone: false
})

export class PaymentProcessingComponent {

  constructor() {

  }
}
